"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
const tslib_1 = require("tslib");
const Divider_1 = tslib_1.__importDefault(require("@material-ui/core/Divider"));
const component_mapper_1 = require("@bluebase/component-mapper");
exports.Divider = component_mapper_1.componentMapper(Divider_1.default, {
    variant: ({ inset }) => inset === true ? 'inset' : 'fullWidth',
}, { rest: true, ignore: ['inset'] });
